import React from "react";
import createRoot from "react-dom";
import App from "./App";
import './index.css'
import './styleguide.css'
import { Auth0Provider } from "@auth0/auth0-react";

createRoot.render(
  <Auth0Provider
    domain="dev-ro0qsq4z.us.auth0.com"
    clientId="iVr4cpbRfpc9eqaXR4CSly6gNgxxFCRc"
    redirectUri={window.location.origin}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);